import { useAuthStore } from '../store/auth';
import { Layout } from '../components/Layout';
import { PublicLayout } from '../components/PublicLayout';

// Content-Komponente für beide Layouts
export function DatenschutzContent() {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Datenschutz auf einen Blick</h2>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Allgemeine Hinweise</h3>
              <p className="text-sm">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
                Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Datenerfassung auf dieser Website</h3>
              <p className="text-sm">
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
                Die Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Hosting</h2>
              <p className="text-sm">
                Diese Website wird bei Hetzner Online GmbH gehostet. Der Hoster erhebt in sog. Logfiles
                folgende Daten, die Ihr Browser übermittelt: IP-Adresse, Datum und Uhrzeit der Anfrage,
                Zeitzonendifferenz zur Greenwich Mean Time, Inhalt der Anforderung, HTTP-Statuscode,
                übertragene Datenmenge, Website, von der die Anforderung kommt, Informationen zu Browser
                und Betriebssystem.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Allgemeine Hinweise und Pflichtinformationen</h2>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Datenschutz</h3>
              <p className="text-sm">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Hinweis zur verantwortlichen Stelle</h3>
              <p className="text-sm">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                Michele Arcaro<br />
                Achterwaldstrasse 12<br />
                70794 Filderstadt<br />
                E-Mail: info@dein-marketing-hub.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Datenerfassung auf dieser Website</h2>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Cookies</h3>
              <p className="text-sm">
                Diese Website verwendet technisch notwendige Cookies für die Authentifizierung.
                Diese Cookies sind erforderlich, damit Sie sich anmelden und die Anwendung nutzen können.
                Sie werden automatisch gelöscht, wenn Sie sich abmelden oder Ihre Browser-Session beenden.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Kontodaten</h3>
              <p className="text-sm">
                Bei der Registrierung speichern wir Ihre E-Mail-Adresse, Ihren Namen (falls angegeben)
                und ein verschlüsseltes Passwort. Diese Daten sind erforderlich, um Ihnen Zugang zur
                Anwendung zu gewähren.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-4 mb-2">Social Media Integration</h3>
              <p className="text-sm">
                Diese Anwendung verbindet sich mit Meta (Facebook/Instagram) APIs, um Posts zu planen
                und zu veröffentlichen. Dabei werden Access Tokens verschlüsselt gespeichert.
                Ihre Social-Media-Inhalte werden nur auf Ihre Anweisung hin veröffentlicht.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Ihre Rechte</h2>
              <p className="text-sm">
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
                personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung
                sowie ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren
                Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Analyse-Tools und Tools von Drittanbietern</h2>
              <p className="text-sm">
                Diese Website verwendet keine Tracking- oder Analyse-Tools von Drittanbietern.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

// Seite mit Auth-abhängigem Layout
export function DatenschutzPage() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return (
      <Layout>
        <DatenschutzContent />
      </Layout>
    );
  }

  return (
    <PublicLayout>
      <DatenschutzContent />
    </PublicLayout>
  );
}
